import { render, staticRenderFns } from "./suppliersList.vue?vue&type=template&id=6c368def&scoped=true&"
import script from "./suppliersList.vue?vue&type=script&lang=js&"
export * from "./suppliersList.vue?vue&type=script&lang=js&"
import style0 from "./suppliersList.vue?vue&type=style&index=0&id=6c368def&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c368def",
  null
  
)

export default component.exports